<!--
 * @Author: zhangchaoqiang
 * @LastEditors: Do not edit
 * @LastEditTime: 2022-03-23 19:35:22
 * @FilePath: /gyl-finace-web/src/App.vue
 * @Description: Do not edit
-->
<template>
<div id="App">
<router-view name="topbar"></router-view>
<router-view name="sidebar"></router-view>
<router-view v-if='isRouterAlive'></router-view>
</div>
</template>
<script>
    export default {
        name: "app",
        provide(){
            return{
                reload:this.reload
            }
        },
        data() {
            return {
                isRouterAlive:true,
            };
        },
        methods: {
            reload(){
                this.isRouterAlive = false;
                this.$nextTick(()=>(this.isRouterAlive = true))
            }
        }
    };
</script>
<style lang="less">
    #App{
       overflow: auto;
       width: 100%;
       height: 100vh;
       background-image: url("./assets/img/body_bg.jpg");
       background-size: 100% 100%;
       background-repeat: no-repeat;
    }
</style>






// WEBPACK FOOTER //
// src/App.vue